import VueRouter from "vue-router";
import home from "@/views/home/";
import essCom from "@/views/ess";
import about from "@/views/about";
import knowledge from "@/views/knowledge";
import partners from "@/views/partners";
import aboutNews from "@/views/home/components/news/aboutNews.vue";
import aboutNewsDetail from "@/views/home/components/news/aboutNewsdetail.vue";
import solution from "@/views/solution";
import intelligentFactory from "@/views/solution/component/intelligent-factory.vue";
import digitalFactory from "@/views/solution/component/digital-factory.vue";
import mesSystem from "@/views/solution/component/mes-system.vue";
import informationSystem from "@/views/solution/component/information-system.vue";
import logisticsManagement from "@/views/solution/component/logistics-management.vue";
import safetyControl from "@/views/solution/component/safety-control.vue";
import machineVision from "@/views/solution/component/machine-vision.vue";
import plateType from "@/views/solution/component/plate-type.vue";
import industrialInternet from "@/views/solution/component/industrial-internet.vue";
import digitalTwin from "@/views/solution/component/digital-twin.vue";

const router = new VueRouter({
  mode: "history",
  routes: [
    //配置路由的路径
    {
      path: "/", //这个表示的是根目录，即一进入的页面
      redirect: "/home",
    },
    {
      path: "/home",
      component: home,
    },
    {
      path: "/about",
      component: about,
    },
    {
      path: "/knowledge",
      component: knowledge,
    },
    {
      path: "/partners",
      component: partners,
    },
    {
      path: "/solution",
      component: solution,
      children: [
        {
          path: "intelligent-factory",
          component: intelligentFactory,
          name: "intelligentFactory",
          meta: {
            showfater: false,
          },
        },
        {
          path: "digital-factory",
          component: digitalFactory,
          name: "digital-factory",
          meta: {
            showfater: false,
          },
        },
        {
          path: "mes-system",
          component: mesSystem,
          name: "mes-system",
          meta: {
            showfater: false,
          },
        },
        {
          path: "information-system",
          component: informationSystem,
          name: "information-system",
          meta: {
            showfater: false,
          },
        },
        {
          path: "logistics-management",
          component: logisticsManagement,
          name: "logistics-management",
          meta: {
            showfater: false,
          },
        },
        {
          path: "safety-control",
          component: safetyControl,
          name: "safety-control",
          meta: {
            showfater: false,
          },
        },
        {
          path: "machine-vision",
          component: machineVision,
          name: "machine-vision",
          meta: {
            showfater: false,
          },
        },
        {
          path: "plate-type",
          component: plateType,
          name: "plate-type",
          meta: {
            showfater: false,
          },
        },
        {
          path: "industrial-internet",
          component: industrialInternet,
          name: "industrial-internet",
          meta: {
            showfater: false,
          },
        },
        {
          path: "digital-twin",
          component: digitalTwin,
          name: "digital-twin",
          meta: {
            showfater: false,
          },
        },
      ],
      meta: {
        showfater: true,
      },
    },
    {
      path: "/aboutNews",
      name: "aboutNews",
      component: aboutNews,
    },
    {
      path: "/aboutNewsDetail",
      name: "aboutNews",
      component: aboutNewsDetail,
    },
    {
      path: "/essWebsite",
      component: essCom,
    },
  ],
  scrollBehavior: () => ({ y: 0 }), // 统一让跳转页面滚动条回到顶部
});
console.log('router',router);
export default router;
